<template>
  <section class="section is-medium">
    <div class="body">
      <div class="container">
        <h1 class="title is-1 has-text-weight-bold has-text-light">Awards</h1>
        <b-carousel-list v-model="test" :data="items" :items-to-show="2" :overlay="true">
          <template slot="item" slot-scope="props">
            <div class="card">
              <div class="card-image">
                <figure class="image is-square">
                  <a @click="info(props.index)">
                    <img :src="props.list.image" />
                  </a>
                </figure>
                <!-- <b-tag type="is-danger" rounded style="position: absolute; top: 10px; left: 10px;">
                  <b>Best Fitness Institute</b>
                </b-tag>-->
              </div>
              <div class="card-content has-background-dark has-text-light">
                <div class="content">
                  <p
                    class="title is-7 has-text-light"
                    style="height: 2rem; padding-bottom: 10px"
                  >{{ props.list.title }}</p>
                  <footer>
                    <p class="is-size-7 has-text-light">
                      <a
                        class="has-text-primary has-text-weight-bold"
                        href="https://www.instagram.com/knockout_fight_club/?hl=en"
                        target="_blank"
                        style="text-shadow: rgb(10, 10, 10) 1px 1px;"
                      >@knockout_fight_club</a>
                    </p>

                    <p class="caption is-size-7 has-text-light">{{ props.list.from }}</p>
                    <!-- <p class="control" style="margin-left: auto">
                      <button class="button is-small is-danger is-outlined">
                        <b-icon size="is-small" icon="heart" />
                      </button>
                    </p>-->
                  </footer>
                </div>
              </div>
            </div>
          </template>
        </b-carousel-list>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      test: 0,
      items: [
        {
          title: "International Healthcare Excellence Award",
          image:
            "https://instagram.fdel8-1.fna.fbcdn.net/v/t51.2885-15/sh0.08/e35/s640x640/80469544_2466719713622186_6998436468228394608_n.jpg?_nc_ht=instagram.fdel8-1.fna.fbcdn.net&_nc_cat=102&_nc_ohc=JeMt6H-j1EYAX-BQlK2&oh=03f8617434a69d371610976096b11771&oe=5EAC3E32",
          from: "by Malaika Arora Khan",
          link: "https://www.instagram.com/p/B6ka9VAHx5r/"
        },
        {
          title: "Global Choice Awards",
          image: require("@/assets/jackie-shroff.jpg"),
          from: "by Jackie Shroff"
        },
        {
          title: "Slide 3",
          image: "https://buefy.org/static/img/placeholder-1280x960.png",
          rating: 5
        },
        {
          title: "Slide 4",
          image: "https://buefy.org/static/img/placeholder-1280x960.png"
        }
      ]
    };
  },
  methods: {
    info(value) {
      this.test = value;
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  height: 100%;
  background-color: #363636;
}

.card-content {
  padding: 0.8em;
}
</style>